import { withState } from 'recompose';

export default withState('state', 'setState', {
  handleModalVisible: false,
  typeOfButton: ''
});
